import { Warning } from '@phosphor-icons/react';
import { useDrag } from 'react-dnd';
import type { ReactNode, Ref } from 'react';
import type { ContainerType, PageElementType } from '../../../dnd-utils';
interface Props {
    pageElementType: PageElementType;
    componentType?: string;
    containerType?: ContainerType | undefined;
    overridden?: boolean;
    label: string;
    icon: ReactNode;
}

const SidebarItem = (props: Props) => {
    const [{ isDragging }, drag] = useDrag(() => ({
        type: 'COMPONENT',
        item: {
            pageElementType: props.pageElementType,
            componentType: props.componentType,
            containerType: props.containerType,
        },
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
    }));

    const opacity = isDragging ? 0.4 : 1;

    if (props.overridden) {
        return (
            <div
                title="A custom component is overriding this standard component"
                className="drag-component draggable"
                style={{ opacity }}
            >
                {props.icon}
                <span>{props.label}</span>
                <Warning className="margin-left-sml" size={20} />
            </div>
        );
    }

    return (
        <div
            title={`Drag ${props.label} component`}
            className="drag-component draggable"
            style={{ opacity }}
            ref={drag as unknown as Ref<HTMLDivElement>}
            data-testid="sidebar-menu-item"
        >
            {props.icon}
            <span>{props.label}</span>
        </div>
    );
};

export default SidebarItem;
